import { useState } from 'react';
import { Input } from 'design-react-kit/dist/design-react-kit';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  closerDate: {
    id: 'Seleziona una data più vicina a',
    defaultMessage: 'Seleziona una data più vicina a',
  },
  requiredField: {
    id: '* Campo obbligatorio',
    defaultMessage: '* Campo obbligatorio',
  },
});

const NumberField = ({ formData, setFormData, filter, error, setError }) => {
  const intl = useIntl();

  /**
   * Number filter validator
   */
  const numberValidator = e => {
    const { value } = e.target;

    setFormData(formData => ({
      ...formData,
      [filter?.propertyField]: value,
    }));

    if (filter?.mandatory && !value) {
      setError(prev => ({
        ...prev,
        [filter?.propertyField]: intl.formatMessage(messages.requiredField),
      }));
    } else {
      setError(prev => ({
        ...prev,
        [filter?.propertyField]: '',
      }));
    }
  };
  return (
    <>
      <Input
        type="number"
        id={filter?.propertyField || filter?.labelField}
        name={filter?.propertyField || filter?.labelField}
        label={
          filter?.mandatory
            ? `${filter?.labelField || filter?.propertyField} * `
            : filter?.labelField || filter?.propertyField
        }
        onChange={numberValidator}
        value={formData?.[filter?.propertyField] || ''}
        className="mt-1 mb-0"
        required={filter?.mandatory}
      />
      {error && (
        <label color="danger" htmlFor="startDate-field" className="mt-0 text-danger lh-1 word-wrap">
          <small>{error}</small>
        </label>
      )}
    </>
  );
};

export default NumberField;
